module.exports = __webpack_public_path__ + "static/media/offer5.452d4464.jpg";